export enum EnumMCConceptos {
  AsignarAgrupador = 'AsignarAgrupador',
  ExpInsumoPorConcepto = 'ExpInsumoPorConcepto',
  CalcularPpto = 'CalcularPpto',
  AjustarPpto = 'AjustarPpto',
  CopiarDesCompletaADes = 'CopiarDesCompletaADes'
}

export enum EnumMCMatriz {
  GuardarComo = 'GuardarComo',
  DuplicarMatrizEn = 'DuplicarMatrizEn',
  AjustarPrecioUnitario = 'AjustarPrecioUnitario',
  RecuperarMatrizOriginal = 'RecuperarMatrizOriginal',
  ImportarMatrizDelMaestro = 'ImportarMatrizDelMaestro',
  Participa = 'Participa',
  EnviarInsumoACotizar = 'EnviarInsumoACotizar'
}

export enum EnumMCPartida {
  NuevaPartida = 'NuevaPartida',
  NuevaPartidaRaiz = 'NuevaPartidaRaiz',
  AgregarNPartidas = 'AgregarNPartidas',
  AgregarNPartidasRaiz = 'AgregarNPartidasRaiz',
  RegenerarWBS = 'RegenerarWBS',
  PegadoEspecial = 'PegadoEspecial',
  EliminarPartida = 'EliminarPartida',
  DuplicarNVecesLaPartida = 'DuplicarNVecesLaPartida',
  IndirectoEspecial = 'IndirectoEspecial',
  RenumerarRenglon = 'RenumerarRenglon',
  CopiarDesCompletaADes = 'CopiarDesCompletaADes',
  TotalizarPpto = 'TotalizarPpto',
  GenerarPartidasPorNiveles = 'GenerarPartidasPorNiveles',
  ExpandirTodo = 'ExpandirTodo',
  ContraerTodo = 'ContraerTodo',
  RenumerarRenglonPartidas = 'RenumerarRenglonPartidas',
}

export enum EnumMCExpInsumos {
  CambiarPropiedadesTipo = 'CambiarPropiedadesTipo',
  AsignarFamiliaIndices = 'AsignarFamiliaIndices',
  QuitarFamiliaIndices = 'QuitarFamiliaIndices',
  AsignarFamilia = 'AsignarFamilia',
  QuitarFamilia = 'QuitarFamilia',
  AsignarProveedor = 'AsignarProveedor',
  QuitarProveedor = 'QuitarProveedor',
  AsignarTipoInsumos = 'AsignarTipoInsumos',
  AsignarUnidad = 'AsignarUnidad',
  Participa = 'Participa',
  Depurar = 'Depurar',
  UnificarCodigos = 'UnificarCodigos',
  MarcarSeleccionados = 'MarcarSeleccionados',
  EnviarInsumosCotizar = 'EnviarInsumosCotizar',
  ActualizarCostoInsumoCotizado = 'ActualizarCostoInsumoCotizado'
}

export enum EnumMCGenerales {
  Matriz = 'Matriz',
  ExpInsumoPorConcepto = 'ExpInsumoPorConcepto',
  Participa = 'Participa',
  FASAR = 'FASAR',
  AsignarTipoJornada = 'AsignarTipoJornada',
  AplicarExpresion = 'AplicarExpresion',
  RenumerarRenglon = 'RenumerarRenglon',
  UnificarUnidades = 'UnificarUnidades',
  DetalleEmpresa = 'DetalleEmpresa',
  DetalleRegistro = 'DetalleRegistro',
  ContactoCliente = 'ContactoCliente',
  SeleccionarTodo = 'SeleccionarTodo',
  DeseleccionarTodo = 'DeseleccionarTodo',
  MarcarTodo = 'MarcarTodo',
  DesmarcarTodo = 'DesmarcarTodo',
  DesmarcarTodoConceptos = 'DesmarcarTodoConceptos',
  Copiar = 'Copiar',
  Pegar = 'Pegar',
  GuardarLayout = 'GuardarLayout',
  ReestablecerLayout = 'ReestablecerLayout',
  AbrirObra = 'AbrirObra',
  AbrirMaestro = 'AbrirMaestro',
  Abrir = 'Abrir',
  Detalle = 'Detalle',
  Borrar = 'Borrar',
  ExplicacionIA = 'ExplicacionIA',
  AgregarMiPresupuesto = 'AgregarMiPresupuesto',
  Nuevo = 'Nuevo',
  Compartir = 'Compartir',
  Respaldar = 'Respaldar',
  CostoHorario = 'CostoHorario'
}

export enum EnumReportes {
  Copiar = 'Copiar',
  Pegar = 'Pegar',
  Borrar = 'Borrar',
  Renombrar = 'Renombrar',
  Generar = 'Generar Reporte'
}

export enum EnumProgramaPorPorcentajeMontos {
  AJUSTARCIENPORCIENTO = 'AJUSTARCIENPORCIENTO',
}
